import { render, staticRenderFns } from "./coursePreview.vue?vue&type=template&id=c35cd166&scoped=true&"
import script from "./coursePreview.vue?vue&type=script&lang=js&"
export * from "./coursePreview.vue?vue&type=script&lang=js&"
import style0 from "./coursePreview.vue?vue&type=style&index=0&id=c35cd166&prod&lang=scss&scoped=true&"
import style1 from "./coursePreview.vue?vue&type=style&index=1&id=c35cd166&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35cd166",
  null
  
)

export default component.exports